import { render, staticRenderFns } from "./RiskAutoAcceptThreshold.vue?vue&type=template&id=a9820834&"
import script from "./RiskAutoAcceptThreshold.vue?vue&type=script&lang=js&"
export * from "./RiskAutoAcceptThreshold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports